// @flow

import Request from '@insolus/request';
import formatProgressPercent from 'utils/formatProgressPercent';

import type { RequestPromise } from '@insolus/request';
import type {
    AllPaginateParams,
    PaginatedResult,
    ProgressFunction
} from 'stores/api/_types';
import type { Ad } from './ads';
import type { Order } from './orders';

type AdvertiserBase = {|
    email: string,
    firstName: string | null,
    firstNameDisplayed: boolean,
    lastName: string | null,
    lastNameDisplayed: boolean,
    companyName: string | null,
    companyNameDisplayed: boolean,
    streetAddress: string | null,
    countryId: string | null,
    localityId: number | null,
    phoneArea: string | null,
    phoneNumber: string | null,
    displayName: string | null,
    avatarUrl: string | null,
    avatar: string | null
|};

export type Advertiser = {|
    ...AdvertiserBase,
    id: number,
    credits: number
|};

export type AdvertiserFormData = {|
    ...AdvertiserBase
|};

// ------------------------------------------------------
// -
// -    Functions
// -
// ------------------------------------------------------

const all = (params?: AllPaginateParams): RequestPromise<PaginatedResult<Advertiser[]>> => (
    Request.get('/members', { params })
);

const edit = (id: number, data: AdvertiserFormData): RequestPromise<Advertiser> => (
    Request.put(`/members/${id}`, data)
);

const editAvatar = (
    id: number, formData: FormData, onProgress: ProgressFunction
): RequestPromise<Advertiser> => (
    Request.post(`/members/${id}/avatar`, formData, {
        onUploadProgress: (e: ProgressEvent) => {
            onProgress(formatProgressPercent(e));
        },
        timeout: 60000
    })
);

const removeAvatar = (id: number): RequestPromise<Advertiser> => (
    Request.delete(`/members/${id}/avatar`)
);

const allAds = (id: number, params?: AllPaginateParams): RequestPromise<PaginatedResult<Ad[]>> => (
    Request.get(`/members/${id}/ads`, { params })
);

const getBill = (billId: number, advertiserId: number): RequestPromise<Order> => (
    Request.get(`/members/${advertiserId}/bills/${billId}`)
);

const get = (id: number): RequestPromise<Advertiser> => (
    Request.get(`/members/${id}`)
);

export default { all, edit, editAvatar, removeAvatar, allAds, getBill, get };
